/** Подсказки для плиток «Управление» и чипов конфигуратора. */

export type ControlInfoEntry = {
  title: string;
  icon: string;
  body: string;
};

const norm = (s: string) => s.trim().toLowerCase().replace(/ё/g, 'е');

const ENTRIES: Record<string, ControlInfoEntry> = {
  'wifi (tuya)': {
    title: 'Wi-Fi (TUYA) / Smart Life',
    icon: '📲',
    body: 'Управление через приложение Smart Life или Tuya. Сценарии, таймеры и голосовые ассистенты через облако Tuya.',
  },
  tuya: {
    title: 'TUYA / Smart Life',
    icon: '📲',
    body: 'Облачная платформа Tuya. Карниз в приложении Smart Life, интеграция с Алисой и Google.',
  },
  zigbee: {
    title: 'ZigBee',
    icon: '🕸️',
    body: 'Mesh-сеть 2.4 ГГц. Низкое энергопотребление, локальные сценарии без интернета. Подходит для АКБ-моторов.',
  },
  matter: {
    title: 'Matter',
    icon: '✨',
    body: 'Единый стандарт умного дома. Работа через хабы Matter и экосистемы с поддержкой Thread/Wi-Fi.',
  },
  'фаза': {
    title: 'Фазное подключение',
    icon: '〰️',
    body: 'Классическое силовое подключение 220 В. Мотор MR-2234F4 — только фаза; MR-2234F5 — фаза плюс доп. интерфейсы.',
  },
  'rs-485': {
    title: 'RS-485',
    icon: '🔗',
    body: 'Промышленная шина для BMS, Wiren Board, KNX-шлюзов и центральной автоматики объекта.',
  },
  'сухой контакт': {
    title: 'Сухой контакт',
    icon: '🔘',
    body: 'Гальванически развязанный вход/выход для сигналов от выключателей, датчиков и реле.',
  },
  'пульт ду': {
    title: 'Пульт ДУ',
    icon: '🎛️',
    body: 'Радиопульт в комплекте или опция. Базовое управление без смартфона и без облака.',
  },
  'смартфон': {
    title: 'Смартфон',
    icon: '📱',
    body: 'Управление из мобильного приложения выбранного протокола (Tuya, ZigBee, Matter).',
  },
  rf: {
    title: 'RF 433 МГц',
    icon: '📡',
    body: 'Радиоканал 433 МГц для пультов и приёмников без IP-сети.',
  },
};

export function getControlOptionInfo(label: string): ControlInfoEntry | null {
  const n = norm(label);
  if (ENTRIES[n]) return ENTRIES[n];
  if (n.includes('tuya') || n.includes('smart life')) return ENTRIES.tuya;
  if (n.includes('zigbee')) return ENTRIES.zigbee;
  if (n.includes('matter')) return ENTRIES.matter;
  if (n.includes('фаз')) return ENTRIES['фаза'];
  if (n.includes('485')) return ENTRIES['rs-485'];
  if (n.includes('сухой')) return ENTRIES['сухой контакт'];
  if (n.includes('пульт')) return ENTRIES['пульт ду'];
  if (n.includes('смартфон')) return ENTRIES['смартфон'];
  return {
    title: label,
    icon: '◽',
    body: 'Опция управления из прайса Onviz для выбранной конфигурации мотора.',
  };
}

export const WORKS_WITH_ECOSYSTEMS: Array<{ id: string; label: string; icon: string; hint?: string }> = [
  { id: 'salyut', label: 'Салют', icon: '🟢', hint: 'Голосовой ассистент Сбер' },
  { id: 'marusia', label: 'Маруся', icon: '💜', hint: 'Голос Mail.ru / VK' },
  { id: 'matter', label: 'Matter', icon: '✨', hint: 'Универсальный стандарт' },
  { id: 'wirenboard', label: 'Wiren Board', icon: '⚙️', hint: 'Локальный контроллер' },
  { id: 'zigbee', label: 'ZigBee', icon: '🕸️', hint: 'Mesh 2.4 ГГц' },
  { id: 'smartlife', label: 'Smart Life', icon: '🏠', hint: 'Tuya / Smart Life' },
  { id: 'knx', label: 'KNX', icon: '🔌', hint: 'Через RS-485 / шлюз' },
  { id: 'alice', label: 'Алиса от Яндекса', icon: '🟣', hint: 'Голос и сценарии умного дома' },
];
